import { render, staticRenderFns } from "./ModalTransferConfirm.vue?vue&type=template&id=33a1f67a&scoped=true&"
import script from "./ModalTransferConfirm.vue?vue&type=script&lang=ts&"
export * from "./ModalTransferConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./ModalTransferConfirm.vue?vue&type=style&index=0&id=33a1f67a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a1f67a",
  null
  
)

export default component.exports